import React from 'react'
import PublicLiveAgoraVideoSurface from './PublicLiveAgoraVideoSurface'

export default function MentorChamberAgoraVideoSurface(props) {
  return <PublicLiveAgoraVideoSurface {...props} />
}

MentorChamberAgoraVideoSurface.displayName = 'MentorChamberAgoraVideoSurface'
